<template>
  <v-content
    class="ma-0 pa-0"
  >

        <!--------------------------------->
        <!--         Main Picture        -->
        <!--------------------------------->
    <v-row
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
      >
        <div
          id="app"
          class="bg1"
        >
          <v-row
            align="center"
            justify="center"
            no-gutters
            class="mx-5"
            style="height: 550px;"
          >
            <v-col
              class="ma-0 pa-0 text-center"
              cols="12"
              xs="12"
              sm="11"
              md="9"
              lg="7"
              xl="6"
            >
              <v-card
                tile
              >
                <v-row
                  class="py-5 px-3"
                  no-gutters
                >
                  <v-col>
                    <v-row
                      align="center"
                      justify="center"
                      class="my-10"
                    >
                      (LOGO HERE)
                    </v-row>
                    <v-col
                      cols="12"
                      class="my-10"
                    >
                      <v-row
                        align="center"
                        justify="center"
                        style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 4px;"
                        no-gutters
                      >
                        Tell us your goals, we'll learn your taste.
                      </v-row>
                      <v-row
                        align="center"
                        justify="center"
                        class="d-none d-sm-flex"
                        style="font-size: 1.2em; font-weight: 400; color: #424242; letter-spacing: 4px;"
                        no-gutters
                      >
                        Enjoy your personalized weekly food plans!
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--    Under Picture Tagline    -->
        <!--------------------------------->
    <v-row
      class="my-7 px-5"
      justify="center"
      style="font-size: 1.1em; font-weight: 400; color: #424242; letter-spacing: 4px;"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0 text-center"
        cols="12"
        xs="12"
        sm="12"
        md="8"
        lg="6"
        xl="6"
      >
        <v-row
          justify="center"
          align="center"
          class="watermark"
          no-gutters
        >
          a smart food planning app for the whole family
        </v-row>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--          Free Trial         -->
        <!--------------------------------->
    <freeTrial
      class="mt-6 mb-4"
    />
        <!--------------------------------->
        <!--          Free Trial         -->
        <!--------------------------------->

        <!--------------------------------->
        <!--        Founder Video        -->
        <!--------------------------------->
    <v-row
      justify="center"
      no-gutters
    >
      <v-col
        class="mb-10"
        cols="12"
        xs="12"
        sm="12"
        md="8"
        lg="7"
        xl="6"
      >
        <v-img
          src="@/assets/main/placeholder.png"
        >
        </v-img>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--    Pandora - But for Food   -->
        <!---------------------------------> 
    <v-row
      no-gutters
    >
      <v-col
        class="my-8 pa-0"
      >
        <div
          id="app"
          class="bg2"
          flat
        >
          <v-row
            align="center"
            justify="center"
            style="height: 360px;"
            class="mx-5"
            no-gutters
          >
            <v-col
              class="ma-0 pa-0 text-center"
              cols="12"
              xs="12"
              sm="12"
              md="8"
              lg="7"
              xl="6"
            >
              <v-card
                tile
              >
                <v-row
                  class="py-5 px-3"
                  no-gutters
                >
                  <v-col>
                    <v-row
                      align="center"
                      justify="center"
                      class="mt-10 mb-7"
                      style="font-size: 1.8em; font-weight: 400; color: #424242; letter-spacing: 3px;"
                    >
                      IT'S LIKE PANDORA - BUT FOR FOOD
                    </v-row>
                    <v-row
                      align="center"
                      justify="center"
                      class="mt-7 mb-10"
                      style="font-size: 0.9em; font-weight: 300; color: #424242; letter-spacing: 2px;"
                      no-gutters
                    >
                      <v-col
                        cols="12"
                        xs="12"
                        sm="11"
                        md="11"
                        lg="10"
                        xl="8"
                      >
                        Adjust weight goals, like or dislike recipes, then let us plan your menu for you.
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row> 

        <!--------------------------------->
        <!--       Block - 6 pieces      -->
        <!--------------------------------->
    <v-row
      justify="center"
      class="mx-5"
      no-gutters
    >
    
    <!--    Size the block section   -->
      <v-col
        class="my-10 pa-0"
        cols="12"
        xs="12"
        sm="12"
        md="8"
        lg="7"
        xl="6"
      >
        <v-row
          no-gutters
        >
    
    <!--         left column         -->
          <v-col
            class="ma-0 pa-0 pr-5"
            cols="6"
          >
            <v-row
              no-gutters
            >
              <v-img
                src="@/assets/main/cooking.png"
              >
              </v-img>
            </v-row>
            <v-row
              class="mt-10"
              no-gutters
            >
              <v-img
                src="@/assets/main/artichokes.png"
              >
              </v-img>
            </v-row>
            <v-row
              class="mt-10"
              no-gutters
              style="font-size: 0.8em; font-weight: 500; color: #424242; letter-spacing: 2px;"
            >
              NEVER BE LEFT GUESSING
            </v-row>
            <v-row
              class="mt-3"
              no-gutters
              style="font-size: 0.8em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              No more counting calories and portion sizes. We deliver personalized weekly menus that are tailored to your family's tastes, diet and weight goals. Use our in-app shopping list for the grocery store or order online for pickup or delivery to make it that much easier. With Smart Food Planner, you never have to worry about what to make for dinner!
            </v-row>
            <v-row
              class="mt-5"
              no-gutters
            >
              <v-btn
                class="ma-0 pa-0 px-3"
                outlined
                tile
                color= "#212121"
                href="#howItWorks"
              >
                <div
                  class="btn1"
                >
                  SEE WHAT YOU GET
                </div>
              </v-btn>
            </v-row>
          </v-col>
    
    <!--         right column        -->
          <v-col
            class="ma-0 pa-0 pl-5"
            cols="6"
          >
            <v-row
              no-gutters
              style="font-size: 0.8em; font-weight: 500; color: #424242; letter-spacing: 2px;"
            >
              FINALLY, A SMART FOOD PLANNING APP!
            </v-row>
            <v-row
              class="mt-3"
              no-gutters
              style="font-size: 0.8em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              Meet Smart Food Planner, an app that is 100% customized to you that takes away the stress of meal planning and preps your pantry perfectly with exactly what you need. It quickly learns what you like and don't like and has access to thousands of recipes while also letting you add your own. Stop overspending on groceries, wasting food and stressing about what's for dinner - we've got you!
            </v-row>
            <v-row
              class="mt-5"
              no-gutters
            >
              <v-btn
                class="ma-0 pa-0 px-3"
                outlined
                tile
                color= "#212121"
                href="#howItWorks"
              >
                <div
                  class="btn1"
                >
                  FIND OUT HOW
                </div>
              </v-btn>
            </v-row>

            <v-row
              class="mt-10"
              no-gutters
            >
              <v-img
                src="@/assets/main/ipad.png"
              >
              </v-img>
            </v-row>
            <v-row
              class="mt-10"
              no-gutters
            >
              <v-img
                src="@/assets/main/salad.png"
              >
              </v-img>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--         Testimonials        -->
        <!---------------------------------> 
    <v-row
      justify="center"
      class="text-center"
      no-gutters
    >
      <v-col
        class="mt-8 mb-10 pa-0"
        cols="12"
        xs="12"
        sm="12"
        md="10"
        lg="8"
        xl="8"
      >
        
        <!--             Row 1           -->
        <v-row
          class="mb-8"
          no-gutters
        >
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              FOODIE
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              FORBES
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              KSL
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
        </v-row>

        <!--             Row 2           -->
        <v-row
          no-gutters
        >
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              FOODIE
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              FORBES
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
          <v-col
            class="mx-3"
          >
            <v-row
              class="mb-5"
              justify="center"
              no-gutters
            >
              KSL
            </v-row>
            <v-row
              no-gutters
            >
              “I'm a testimonial. Click to edit me
              and add text that says something nice
              about you and your services.”
            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

        <!------------------------------------------------------->
        <!--                 Begin How it Works                -->
        <!------------------------------------------------------->
    <!--           Divider           -->
    <v-row
      id="howItWorks"
      class="mt-10"
      justify="center"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
        xs="12"
        sm="8"
        md="6"
        lg="4"
        xl="4"
      >
        <v-divider
          color="#424242"
        >
        </v-divider>
      </v-col>
    </v-row>
    
    <v-row
      class="my-10"
      no-gutters
    >
      <v-col
        class="text-center ma-0 pa-0"
        cols="12"
        style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
      >
        IT'S AS EASY AS...
      </v-col>
    </v-row>
    
    <!--           Divider           -->
    <v-row
      class="mb-10"
      justify="center"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
        xs="12"
        sm="8"
        md="6"
        lg="4"
        xl="4"
      >
        <v-divider
          color="#424242"
        >
        </v-divider>
      </v-col>
    </v-row>

        <!--------------------------------->
        <!--          Steps xs-          -->
        <!--------------------------------->
    <v-row
      justify="center"
      class="text-center mx-5 mb-5 d-sm-none"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
      >

      <!--           Step 1            -->
        <v-row
          class="ma-0 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              1. tell us what you like
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/phone.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
            >
              {{step1text}}
            </v-row>
          </v-col>
        </v-row>

    <!--           Step 2            -->
        <v-row
          class="my-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
                justify="center"
                no-gutters
                style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
              >
              2. get your custom menu
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/ipad.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
            >
              {{step2text}}
            </v-row>
          </v-col>
        </v-row>

        <!--           Step 3            -->
        <v-row
          class="ma-0 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              3. shop, cook & enjoy
            </v-row>

            <v-row
              class="my-3"
              no-gutters
            >
              <v-img
                src="@/assets/main/enjoy.png"
                :aspect-ratio="912/638"
              >
              </v-img>
            </v-row>

            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px; text-align: justify;"
            >
              {{step3text}}
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


        <!--------------------------------->
        <!--          Steps sm+          -->
        <!--------------------------------->
    <v-row
      justify="center"
      class="text-center mb-5 d-none d-sm-flex"
      no-gutters
    >
      <v-col
        class="ma-0 pa-0"
        cols="12"
        xs="12"
        sm="11"
        md="8"
        lg="7"
        xl="6"
      >

      <!--           Step 1            -->
        <v-row
          class="mt-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-img
              src="@/assets/main/phone.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              1
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              tell us what you like
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              {{step1text}}              
            </v-row>
          </v-col>
        </v-row>

    <!--           Step 2            -->
        <v-row
          class="my-12 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              2
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              get your custom menu
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              {{step2text}}
            </v-row>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-img
              src="@/assets/main/ipad.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
        </v-row>

        <!--           Step 3            -->
        <v-row
          class="mb-5 pa-0"
          justify="center"
          align="center"
          no-gutters
        >
          <v-col
            cols="6"
            class="pr-5"
          >
            <v-img
              src="@/assets/main/enjoy.png"
              :aspect-ratio="912/638"
            >
            </v-img>
          </v-col>
          <v-col
            cols="6"
            class="pl-5"
          >
            <v-row
              justify="center"
              no-gutters
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            >
              3
            </v-row>
            <v-row
              justify="center"
              class="my-3"
              no-gutters
              style="font-size: 1.3em; font-weight: 500; color: #424242; letter-spacing: 1px;"
            >
              shop, cook & enjoy
            </v-row>
            <v-row
              justify="center"
              no-gutters
              style="font-size: 0.9em; font-weight: 400; color: #424242; letter-spacing: 1px;"
            >
              {{step3text}}
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->
    <freeTrial
      class="mt-10"
    />
    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->

        <!--------------------------------->
        <!--         Explanation         -->
        <!--------------------------------->
    <v-row
      class="mt-5 mb-10"
      no-gutters
    >
      <div
        class="bg3"
      >
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="d-none d-sm-flex my-10 px-0 text-center"
            style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            cols="12"
            xs="12"
            sm="11"
            md="6"
            lg="5"
            xl="4"
          >
            A MEAL PLANNING APP THAT'S THOUGHT OF EVERYTHING, FINALLY.
          </v-col>
          <v-col
            class="d-sm-none my-10 px-3 text-center"
            style="font-size: 1.4em; font-weight: 400; color: #424242; letter-spacing: 3px;"
            cols="12"
            xs="12"
            sm="11"
            md="6"
            lg="5"
            xl="4"
          >
            A MEAL PLANNING APP THAT'S THOUGHT OF EVERYTHING, FINALLY.
          </v-col>
        </v-row>
        <v-row
          justify="center"
          no-gutters
        >
          <v-col
            class="mb-10 pa-0"
            cols="12"
            xs="12"
            sm="11"
            md="8"
            lg="7"
            xl="6"
          >
            <v-row
              justify="center"
              no-gutters
            >

        <!--        Nutritionist         -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/nutritionist.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    NUTRITIONIST
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  justify="center"
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  We create the perfect weekly meal plans that take into account exactly how many calories and macros each family member should be eating. We automatically scale your family's recipes to fit you and even help you with proportion sizes each family member should eat so you can all meet your goals without any of the headache. Oh, and we also keep track of everything so you don't have to. 
                </v-row>
              </v-col>

        <!--          Assistant          -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/assistant.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    ASSISTANT
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  It's like having a second you in the kitchen. We learn what you like and don't like with each recipe you cook to give you true, custom meals you know you'll love without the work. You can also add your own recipes, create recurring dinner themes and even holiday menus!
                </v-row>
              </v-col>

          <!--         Meal Planner        -->
              <v-col
                class="px-3"
                cols="4"
              >
                <v-row
                  no-gutters
                >
                  <v-img
                    src="@/assets/main/planner.png"
                    :aspect-ratio="240/300"
                  >
                  </v-img>
                </v-row>
                <v-row
                  justify="center"
                  no-gutters
                >
                  <div
                    class="label1"
                  >
                    PLANNER
                  </div>
                </v-row>
                <v-row
                  class="mt-3"
                  no-gutters
                  style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                >
                  How about a full day's meals and snacks pre-planned for you and the entire family each week without even having to think about it? Yea, that's exactly what we deliver. No limited options here, we have thousands of recipes and accommodate the most popular diets. 
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->
        <freeTrial
          class="mt-5"
        />
    <!--------------------------------->
    <!--          Free Trial         -->
    <!--------------------------------->

        <!--------------------------------->
        <!--How About Getting Used To xs -->
        <!--------------------------------->
        <v-row
          class="d-sm-none"
          justify="center"
          no-gutters
        >
          <v-col>
            <v-row
              class="mt-5 mb-1"
              justify="center"
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 1px;"
              no-gutters
            >
              <v-col
                class="text-center mx-3 pa-0"
                cols="12"
              >
                HOW ABOUT GETTING USED TO
              </v-col>
            </v-row>

            <v-row
              class="mb-10"
              no-gutters
            >
              <div
                class="bg4"
              >
                <v-row
                justify="center"
                no-gutters
                >
                  <v-col
                    class="my-10 mx-5 pa-0 text-center"
                    cols="12"
                    xs="12"
                    sm="11"
                    md="8"
                    lg="7"
                    xl="6"
                  >
                    <div>
                      <v-row
                        no-gutters
                      >
                        <v-col
                          class="mx-3"
                        >

              <!--  meeting your weight goals  -->
                          <v-row
                            class="mb-1"
                            no-gutters
                            align="center"
                            justify="center"
                          >
                            <v-img
                              src="@/assets/main/scale.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            meeting your weight goal
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Know exactly how much to eat each meal to reach your goal. We make it easy by calculating calories and macros to get you there without the headache.
                          </v-row>

              <!--    staying in your budget   -->
                          <!-- <v-row
                            class="mt-10 mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/piggy-bank.png"
                              style="max-width: 40px;"
                              class="ml-2"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            staying in your grocery budget
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            No need to add up totals in your head, with estimated recipe costs included with each menu it's easy to stay within your budget and still have a full week of delicious meals.
                          </v-row> -->
                        </v-col>

              <!--      never wasting food     -->
                        <v-col
                          class="mx-3"
                        >
                          <v-row
                            class="mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/earth.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            no more wasted food (or money!)
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            We scale each recipe to fit your family and even plan when to eat your leftovers. Say goodbye to wasted food! Every ingredient you buy and recipe you cook is accounted for.
                          </v-row>

              <!--  time for what matters most -->
                          <!-- <v-row
                            class="mt-10 mb-1"
                            align="center"
                            justify="center"
                            no-gutters
                          >
                            <v-img
                              src="@/assets/main/ribbon.png"
                              style="max-width: 40px;"
                              class="ml-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            more time for what matters
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Hang out with your family, spend time crushing your goals or get that much needed relax time in. However you spend the time you saved using Smart Food Planner, we're sure you'll enjoy it. 
                          </v-row> -->
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>        
              </div>
            </v-row>
          </v-col>
        </v-row>

        <!--------------------------------->
        <!--How About Getting Used To sm+-->
        <!--------------------------------->
        <v-row
          class="d-none d-sm-flex"
          justify="center"
          no-gutters
        >
          <v-col>
            <v-row
              class="mt-5 mb-1"
              justify="center"
              style="font-size: 1.5em; font-weight: 400; color: #424242; letter-spacing: 1px;"
              no-gutters
            >
              <v-col
                class="text-center mx-3 pa-0"
                cols="12"
              >
                HOW ABOUT GETTING USED TO
              </v-col>
            </v-row>

            <v-row
              class="mb-10"
              no-gutters
            >
              <div
                class="bg4"
              >
                <v-row
                justify="center"
                no-gutters
                >
                  <v-col
                    class="my-10 mx-5 pa-0 text-center"
                    cols="12"
                    xs="12"
                    sm="11"
                    md="8"
                    lg="7"
                    xl="6"
                  >
                    <div>
                      <v-row
                        no-gutters
                      >
                        <v-col
                          class="ml-3 mr-12"
                        >

              <!--  meeting your weight goals  -->
                          <v-row
                            class="mb-3"
                            no-gutters
                            align="center"
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            <v-img
                              src="@/assets/main/scale.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                            meeting your weight goal
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Know exactly how much to eat each meal to reach your goal. We make it easy by calculating calories and macros to get you there without the headache.
                          </v-row>

              <!--    staying in your budget   -->
                          <!-- <v-row
                            class="mt-10 mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            staying in your grocery budget
                            <v-img
                              src="@/assets/main/piggy-bank.png"
                              style="max-width: 40px;"
                              class="ml-2"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            No need to add up totals in your head, with estimated recipe costs included with each menu it's easy to stay within your budget and still have a full week of delicious meals.
                          </v-row> -->
                        </v-col>

              <!--      never wasting food     -->
                        <v-col
                          class="ml-12 mr-3"
                        >
                          <v-row
                            class="mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            <v-img
                              src="@/assets/main/earth.png"
                              style="max-width: 40px;"
                              class="mr-1"
                            >
                            </v-img>
                            no more wasted food (or money!)
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            We scale each recipe to fit your family and even plan when to eat your leftovers. Say goodbye to wasted food! Every ingredient you buy and recipe you cook is accounted for.
                          </v-row>

              <!--  time for what matters most -->
                          <!-- <v-row
                            class="mt-10 mb-3"
                            align="center"
                            no-gutters
                            style="font-size: 1.0em; font-weight: 500; color: #424242; letter-spacing: 1px;"
                          >
                            more time for what matters most
                            <v-img
                              src="@/assets/main/ribbon.png"
                              style="max-width: 40px;"
                              class="ml-1"
                            >
                            </v-img>
                          </v-row>
                          <v-row
                            no-gutters
                            style="font-size: 0.8em; font-weight: 400; color: #424242; text-align: justify;"
                          >
                            Hang out with your family, spend time crushing your goals or get that much needed relax time in. However you spend the time you saved using Smart Food Planner, we're sure you'll enjoy it. 
                          </v-row> -->
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>        
              </div>
            </v-row>
          </v-col>
        </v-row>

        <!--       End Explanation       -->
      </div>
    </v-row>

  </v-content>
</template>

<script>
  import freeTrial from '@/components/login/startFreeTrialButton.vue'

export default {
  components: {
    freeTrial
  },

  mounted () {
    if (window.location.href.indexOf("auth") >= 0) {
      this.$store.dispatch('login/authDialog',true);
    }
  },

  data: () => ({
    step1text: 'Customize your profile with the kind of food you like, your weight goals, and even allergies or restrictions! Have family members with different goals? Not a problem, you can personalize your profile for everyone at the table.',
    step2text: 'We then create a full week\'s menu with delicious, easy meals that match your preferences perfectly. breakfast, lunch, dinner and even snacks all planned with a shopping list ready to go. Don\'t have time to shop? We\'ve got you covered there too with online ordering options available in just a few clicks.',
    step3text: 'Cheers to to never having to stress about what\'s for dinner again! You\'re now stocked with the exact ingredients you need to make meals that fit your lifestyle perfectly. All you have to do is cook and enjoy!',
  }),

  computed: {
    
  },

  methods: {
    // scrollMeTo(refName) {
    //   console.log('scrollMeTo(refName)',refName);
      
    //   let container = this.$refs['body'];
    //   console.log('container',container);
      
    //   let element = this.$refs[refName];
    //   console.log('element',element);
      
    //   let offset = element.offsetTop;
    //   console.log('offset',offset);

    //   container.scrollTop = offset;
    //   console.log('scroll done');
    // }

  },

}
</script>

<style scoped>
  .bg1 {
    background: url(../assets/main/background1.png);
    height: 550px;
    width: 100%;
    background-size: cover;
  }

  .bg2 {
    background: url(../assets/main/background2.png);
    height: 360px;
    width: 100%;
    background-size: cover;
  }

  .bg3 {
    background: #f4f4f4;
    height: 425px;
    width: 100%;
  }

  .bg4 {
    background: url(../assets/main/background4.png);
    height: min-content;
    width: 100%;
    background-size: cover;
    background-position: center center;
  }

  .label1 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.8em;
    font-weight: 300;
    height: 24px;
    width: 130px;
    color: #ffffff;
    background: #a3e85f;
    text-align: center;
    padding: 3px 0px 0px 0px;
    position: relative;
    top: -12px;
  }

  .watermark {
    background: url(../assets/main/watermark.png);
    background-repeat: no-repeat;
    background-size: 80px;
    background-position: 20px center;
    height: 80px;
  }

  .btn1 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #212121;
    text-align: center;
  }

</style>